import { isProduction } from '~/stage';

export const getDashboardUrl = (path?: string) => {
  const baseUrl = isProduction()
    ? 'https://dashboard.followathletics.com'
    : 'http://localhost:5000';
  const url = `${baseUrl}${path || ''}`;

  return url;
};

export const getAppStoreUrl = () => {
  return 'https://apps.apple.com/us/app/followathletics-app/id6738388569';
};
